import { FC } from 'react';
import { Link } from 'react-router-dom';

import { logEvent } from 'features/Analytics/analytics';
import * as OfferDetailsLayout from 'layouts/OfferDetailsLayout';

import locales from './locales';

interface ActivateInsuranceButtonProps {
  offerName: string;
}

const ActivateInsuranceButton: FC<ActivateInsuranceButtonProps> = ({
  offerName,
}) => (
  <Link to="/upgrade/choice">
    <OfferDetailsLayout.HeaderCta
      icon="lock"
      iconPosition="right"
      onClick={() => {
        logEvent({
          name: 'InsuranceOfferDetails ActivateInsurance Clicked',
          properties: {
            offer: offerName,
          },
          usePrefix: false,
        });
      }}
    >
      {locales.title}
    </OfferDetailsLayout.HeaderCta>
  </Link>
);

export default ActivateInsuranceButton;
